import apiClient from './apiClient';
import { API_ENDPOINTS } from '../utils/constants';

export const networkApi = {
  searchOpenNetworks: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SEARCH_OPEN_NETWORKS);
      return response.data;
    } catch (error) {
      console.error('Error fetching networks:', error);
      throw error;
    }
  },

  getNetworkBySubdomain: async (subdomain) => {
    try {
      console.log('Fetching network by subdomain:', subdomain);
      const response = await apiClient.get(API_ENDPOINTS.FETCH_NETWORK_BY_SUBDOMAIN + subdomain);

      if (response.data.result && response.data.result.length > 0) {
        const networks = response.data.result;

        if (networks.length === 1) {
          return networks[0];
        }

        // Clean the input subdomain for comparison
        const cleanSubdomain = subdomain.replace(/-/g, ' ').toLowerCase();
        const cleanSubdomainNoSpaces = subdomain.replace(/[-\s]/g, '').toLowerCase();

        // Find the network with matching subdomain
        const targetNetwork = networks.find(n => {
          const nSubdomain = n.subDomain?.toLowerCase() || '';
          const nSubdomainNoSpaces = n.subDomain?.replace(/\s+/g, '').toLowerCase() || '';
          const nSubdomainWithHyphens = n.subDomain?.replace(/\s+/g, '-').toLowerCase() || '';

          return (
            nSubdomain === cleanSubdomain ||
            nSubdomainNoSpaces === cleanSubdomainNoSpaces ||
            nSubdomainWithHyphens === subdomain.toLowerCase() ||
            n.subDomain === subdomain ||
            nSubdomain === subdomain.toLowerCase()
          );
        });

        if (targetNetwork) {
          return targetNetwork;
        }

        return networks[0];
      }

      return null;
    } catch (error) {
      console.error('Error fetching network by subdomain:', error);
      throw error;
    }
  },

  getNetworkByCode: async (networkCode) => {
    try {
      console.log('Fetching network by code:', networkCode);
      const response = await apiClient.get(API_ENDPOINTS.FETCH_NETWORK_BY_CODE + networkCode);

      if (response.data.result && response.data.result.length > 0) {
        const networks = response.data.result;

        if (networks.length === 1) {
          return networks[0];
        }

        // Clean the input code for comparison
        const cleanCode = networkCode.replace(/-/g, ' ').toLowerCase();
        const cleanCodeNoSpaces = networkCode.replace(/[-\s]/g, '').toLowerCase();

        // Find the network with matching code
        const targetNetwork = networks.find(n => {
          const nCode = n.code?.toLowerCase() || '';
          const nCodeNoSpaces = n.code?.replace(/\s+/g, '').toLowerCase() || '';
          const nCodeWithHyphens = n.code?.replace(/\s+/g, '-').toLowerCase() || '';

          return (
            nCode === cleanCode ||
            nCodeNoSpaces === cleanCodeNoSpaces ||
            nCodeWithHyphens === networkCode.toLowerCase() ||
            n.code === networkCode ||
            nCode === networkCode.toLowerCase()
          );
        });

        if (targetNetwork) {
          return targetNetwork;
        }

        return networks[0];
      }

      return null;
    } catch (error) {
      console.error('Error fetching network by code:', error);
      throw error;
    }
  },

  getNetworkByName: async (networkName) => {
    try {
      console.log('Fetching network by name:', networkName);
      const response = await apiClient.get(API_ENDPOINTS.FETCH_NETWORK_BY_NAME + networkName);

      if (response.data.result && response.data.result.length > 0) {
        const networks = response.data.result;

        if (networks.length === 1) {
          return networks[0];
        }

        // Clean the input name for comparison
        const cleanName = networkName.replace(/-/g, ' ').toLowerCase();
        const cleanNameNoSpaces = networkName.replace(/[-\s]/g, '').toLowerCase();

        // Find the network with matching name
        const targetNetwork = networks.find(n => {
          const nName = n.name.toLowerCase();
          const nNameNoSpaces = n.name.replace(/\s+/g, '').toLowerCase();
          const nNameWithHyphens = n.name.replace(/\s+/g, '-').toLowerCase();

          return (
            nName === cleanName ||
            nNameNoSpaces === cleanNameNoSpaces ||
            nNameWithHyphens === networkName.toLowerCase() ||
            n.name === networkName ||
            n.name.replace(/\s+/g, '') === networkName
          );
        });

        if (targetNetwork) {
          return targetNetwork;
        }

        return networks[0];
      }

      return null;
    } catch (error) {
      console.error('Error fetching network by name:', error);
      throw error;
    }
  },

  getNetworkById: async (id) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.FETCH_NETWORK_BY_ID + id);

      if (response.data.result && response.data.result.length > 0) {
        const networks = response.data.result;

        if (networks.length === 1) {
          return networks[0];
        }

        const targetNetwork = networks.find(n => n.businessNetworkID.toString() === id.toString());
        if (targetNetwork) {
          return targetNetwork;
        }

        return networks[0];
      }

      return null;
    } catch (error) {
      console.error('Error fetching network by ID:', error);
      throw error;
    }
  },

  getHotNetworks: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SEARCH_OPEN_NETWORKS);
      const networks = response.data.result || [];
      return networks.filter(n => n.isHot);
    } catch (error) {
      console.error('Error fetching hot networks:', error);
      throw error;
    }
  },

  getFavoriteNetworks: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SEARCH_OPEN_NETWORKS);
      const networks = response.data.result || [];
      return networks.filter(n => n.isFavorite);
    } catch (error) {
      console.error('Error fetching favorite networks:', error);
      throw error;
    }
  },

  getRecentNetworks: async (count = 5) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SEARCH_OPEN_NETWORKS);
      const networks = response.data.result || [];
      return networks.slice(0, count);
    } catch (error) {
      console.error('Error fetching recent networks:', error);
      throw error;
    }
  }
};
